import { render, staticRenderFns } from "./UsersTablePending.vue?vue&type=template&id=5350c6fb&"
import script from "./UsersTablePending.vue?vue&type=script&lang=js&"
export * from "./UsersTablePending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports